var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn_style",attrs:{"elevation":"0"},on:{"click":_vm.emitClick}},[_c('v-icon',{attrs:{"size":"16"}},[_vm._v(_vm._s(_vm.icons.mdiTrayArrowDown))]),_c('span',{staticClass:"pl-2"},[_vm._v("Export")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }